
<div class="card" *ngIf="DynamicFields.campi">
  <div [ngClass]="{ 'card-body': true }">
    <app-field-viewer [(Oggetto)]="Item" [CampiNascosti]="CampiNascosti" [Campi]="DynamicFields.campi" (OnChange)="ChangeHandler($event)" ></app-field-viewer>
  </div>
</div>
<div [ngClass]="{'card': true }" *ngIf="DynamicFields.sezioni && !ResetFields">
  <div [ngClass]="{'modal-body': true, 'card-body': !true }">
    <app-sector-viewer [(DropdownSources)]="DropdownSources" (OnFilter)="FilterHandler($event)" (OnChange)="ChangeHandler($event)" [(Campi)]="DynamicFields.sezioni" [(Oggetto)]="Item"></app-sector-viewer>

  </div>
</div>